import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Spinner } from "react-bootstrap";

const FollowerTab = ({
  followersData,
  isFollowersLoading,
  isFollowersError,
  handleFollowerClick,
  handleFollow,
  localFollowingIds,
  user,
  t,
}) => {
  if (isFollowersLoading)
    return (
      <p className="justify-content-center text-center">
        <Spinner />
      </p>
    );

  if (!followersData?.data?.length || isFollowersError)
    return (
      <p className="justify-content-center text-center text-muted">
        {t("noFollowersFound")}
      </p>
    );

  return (
    <div className="row justify-content-center">
      <div className="col-lg-8">
        {followersData?.data?.map((follower) => {
          const fullName =
            `${follower?.first_name || ""} ${follower?.last_name || ""}`.trim();
          const initials = `${follower?.first_name?.[0] || ""}${follower?.last_name?.[0] || ""}`;
          const targetUserId = follower._id || follower.created_by;
          const isAlreadyFollowing = localFollowingIds.has(targetUserId);
          const isOwnProfile = user?._id === follower?.created_by;
          const isVerified =
            (follower?.verification_status ||
              follower?.creator_obj?.verification_status) === "verified";

          return (
            <div
              key={follower._id}
              onClick={() => handleFollowerClick(follower)}
              className="d-flex align-items-center justify-content-between p-3 mb-3 rounded follower-row"
              style={{ background: "#0e0e18", cursor: "pointer" }}
            >
              <div className="follower-row-info">
                <div className="follower-row-avatar">
                  {follower?.picture ? (
                    <img
                      src={follower.picture}
                      alt={fullName}
                      className="rounded-circle"
                      style={{
                        width: 45,
                        height: 45,
                        objectFit: "cover",
                        flexShrink: 0,
                      }}
                    />
                  ) : (
                    <div
                      className="d-flex align-items-center justify-content-center rounded-circle fw-bold"
                      style={{
                        width: 45,
                        height: 45,
                        backgroundColor: "#2a2a40",
                        color: "#fff",
                        flexShrink: 0,
                      }}
                    >
                      {initials || "U"}
                    </div>
                  )}
                </div>
                <div className="follower-row-text">
                  <p
                    className="mb-0 follower-row-name d-flex align-items-center gap-2"
                    style={{ color: "#fff" }}
                  >
                    <span className="follower-row-name-text">{fullName}</span>
                    {isVerified && (
                      <span className="follower-name-verified">
                        <FontAwesomeIcon
                          icon={faCheck}
                          style={{ fontSize: "10px" }}
                        />
                      </span>
                    )}
                  </p>
                  <p
                    className="mb-0 text-muted follower-row-tagline"
                    style={{ color: "#fff", fontSize: "14px" }}
                  >
                    {follower?.tagline ||
                      follower?.headline ||
                      follower?.bio ||
                      t("noDescription")}
                  </p>
                </div>
              </div>
              {!isOwnProfile && (
                <button
                  className={`follower-row-action ${isAlreadyFollowing ? "site-btn border-btn" : "site-btn"}`}
                  style={{
                    minWidth: "auto",
                    padding: "8px 32px",
                  }}
                  onClick={async (e) => {
                    e.stopPropagation(); // prevent profile navigation
                    await handleFollow(follower);
                  }}
                >
                  {isAlreadyFollowing ? t("following") : t("follow")}
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FollowerTab;
